///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-category.ts"/>


module Meevo.Components.Controls.SmartMover {


    import DP005ProductCategory = Meevo.Plugins.Reports.DP005ProductCategory;
    import IReportDP005Product = Meevo.Plugins.Reports.IReportDP005Product;

    export class ProductsToCategoriesStrategy implements ICollectionPopulate {
        constructor(private productCategories: ICollectionBase<DP005ProductCategory>,
                    private products: ICollectionBase<IReportDP005Product>) {
        }

        populate(): void {
            if (this.products.models.length === 0) {
                return;
            }

            for (const category of this.productCategories.models) {
                (<ISmartMoverCategoryModel<DP005ProductCategory>>category).resetModels(
                    this.products.models.filter(product => {
                        return category.get('cat_TId') === product.get('dP005ProductCategories')[0].cat_TId;
                    })
                )
            }
        }
    }
}
